import React from "react";
import UserStepsItem from "./UserStepsItem";

const UserStepsList = () => {
  return (
    <>
      <UserStepsItem />
      <UserStepsItem />
      <UserStepsItem />
      <UserStepsItem />

      <UserStepsItem />
    </>
  );
};

export default UserStepsList;
